import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

// Hot表示ルール
// | スコア | 表示 | 意味 |
// | 1-5    | 🔥🔥🔥 | Super Hot（最優先） |
// | 6-10   | 🔥🔥   | Hot |
// | 11-17  | 🔥     | Warm |
// | null   | （なし） | AI生成以外 |
const SUPER_HOT_MAX = 5;
const HOT_MAX = 10;
const WARM_MAX = 17;

const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '45px',
    marginRight: '8px',
    fontSize: '14px',
    lineHeight: 1,
  },
});

/**
 * Hotスコア表示コンポーネント
 *
 * AI生成リストのキーマンに対して、マッチ度合いを🔥アイコンで表示する。
 * スコアが低いほど「Hot」（条件にマッチしている）。
 */
class HotScore extends React.PureComponent {
  /**
   * スコアに基づいて🔥アイコンを返す
   */
  getHotIcons = () => {
    const { score } = this.props;

    if (score === null || score === undefined) {
      return null;
    }

    if (score <= SUPER_HOT_MAX) {
      return '🔥🔥🔥';
    }

    if (score <= HOT_MAX) {
      return '🔥🔥';
    }

    if (score <= WARM_MAX) {
      return '🔥';
    }

    return null;
  }

  render() {
    const { classes, score } = this.props;
    const icons = this.getHotIcons();

    // スコアがない場合は何も表示しない
    if (icons === null || score === null || score === undefined) {
      return <div className={classes.container} />;
    }

    return (
      <div className={classes.container} title={`Hotスコア: ${score}`}>
        {icons}
      </div>
    );
  }
}

HotScore.propTypes = {
  classes: PropTypes.object.isRequired,
  score: PropTypes.number,
};

export default withStyles(styles)(HotScore);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/cols/HotScore.jsx